import React from 'react'
import SalesOrderDetails from '../Components/Admin/SalesOrderDetails'

function SalesOrderDetailsPage() {
  return (
    <div className="salesorder-details-page min-h-screen bg-[#f8fafc]">
      <SalesOrderDetails />
    </div>
  )
}

export default SalesOrderDetailsPage
